<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-icon
        v-on="on"
        :color="
          alertPrio !== '0' && associatedIcon
            ? associatedIcon.color
            : 'background'
        "
      >
        {{ associatedIcon && associatedIcon.icon }}
      </v-icon>
    </template>
    <span>
      <div>{{ datetime && datetime.toLocaleDateString() }}</div>
    </span>
  </v-tooltip>
</template>
<script>
export const iconLogbookArray = [
  {
    icon: 'mdi-asterisk',
    color: '#FF0000',
    alert: 'Devis / Chantiers travaux',
  },
  {
    icon: 'mdi-circle-outline',
    color: '#ADADAD',
    alert: 'Commentaires STE Installation / Comptages',
  },
  {
    icon: 'mdi-triangle-outline',
    color: '#00FF00',
    alert: "Actions / Plans d'actions",
  },
  {
    icon: 'mdi-square-outline',
    color: '#0000FF',
    alert: 'Relèves ADICT - GRDF',
  },
];
export const diversIconArray = [
  {
    icon: 'mdi-cached',
    color: '#00FF00',
    alert: 'Dézoom automatique',
  },
];
export default {
  name: 'LogbookIcon',
  props: {
    datetime: { type: Date },
    alertName: { type: String },
    alertPrio: { type: String },
  },
  computed: {
    associatedIcon() {
      return iconLogbookArray.find((item) => item.alert === this.alertName);
    },
  },
};
</script>
